// eslint-disable-next-line import/no-cycle
import NetworkContent from '@/helpers/networking/NetworkContent';

export default {
  state: {
    externalEvaluationParticipants: [],
  },
  getters: {
    getExternalEvaluationParticipants: (state) => state.externalEvaluationParticipants,
  },
  mutations: {
    setExternalEvaluationParticipants: (state, data) => {
      const participants = [];
      data.users.forEach((el) => {
        if (el.name !== data.loggedInName) {
          participants.push({
            _id: el.id,
            name: el.name,
            teams: el.teams,
            isChecked: false,
          });
        }
      });
      state.externalEvaluationParticipants = participants;
    },
    updateExternalEvaluationParticipantSelection: (state, index) => {
      state.externalEvaluationParticipants[index]
        .isChecked = !state.externalEvaluationParticipants[index].isChecked;
    },
    resetExternalEvaluationParticipants: (state) => {
      state.externalEvaluationParticipants = [];
    },
  },
  actions: {
    async getExternalEvaluationParticipants({ commit }, loggedInName) {
      const { data } = await NetworkContent.getParticipants();
      commit('setExternalEvaluationParticipants', {
        users: data.users,
        loggedInName,
      });
    },
    async createExternalEvaluation({ commit, dispatch }, data360) {
      const { data } = await NetworkContent.createExternalEvaluation(data360);
      if (data.success) {
        commit('resetExternalEvaluationParticipants');
        await dispatch('getUserInfo', null, { root: true });
      }
    },
  },
};
